import { yupResolver } from "@hookform/resolvers/yup";
import FormInput from "components/Common/Form/FormInput";
import { useTransportGroupData } from "components/Common/GroupTransportSelect";
import MessageFormValidate from "components/shared-components/MessageFormValidate";
import { actionAccess } from "constants/actionAccess";
import { SHIPPING_TYPE, TIME_SLOT_TYPE } from "constants/order";
import { getPhoneValidation } from "constants/validate";
import { formValidate } from "helpers/form_helper";
import {
  CheckActionAccess,
  checkIsInFixedDaysOff,
  checkOutSideDateAndTime,
  getTimeSlot,
  isAnyShift,
  useQueryRouter,
} from "helpers/utils";
import { useListHolidayWithTime } from "hooks/holiday/useHoliday";
import { isEmpty } from "lodash";
import moment from "moment";
import PropTypes from "prop-types";
import React, { useEffect, useLayoutEffect, useState } from "react";
import { SingleDatePicker } from "react-dates";
import { Controller, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import Select from "react-select";
import {
  Button,
  Card,
  Col,
  Form,
  FormGroup,
  InputGroup,
  Label,
  Modal,
  Row,
} from "reactstrap";
import * as yup from "yup";
import UploadForm from "../../../components/shared-components/UploadForm";
import {
  useDetailCustomerLocationByOrder,
  useGetCustomerLocationTransports,
  useListBus,
  useTimeSlots,
  useUploadResource,
} from "../../../hooks";
import "../OrdersForm/OrdersForm.scss";
import LocationCustomerForm from "./CreateLocationCustomerForm";
import SaleSelect from "./SaleSelect";

const USE_TIME_SLOT_RULE = true;

const convertObjectToArray = object => {
  if (isEmpty(object)) return [];
  const objectValue = object && Object.keys(object);
  return objectValue.map(item => ({ label: object?.[item], value: item }));
};

const checkIsDisableDate = (
  date,
  listHolidays,
  fixedDaysOff,
  timeSlotMenu,
  isHCMOrder_,
  is_grab_
) => {
  return (
    !isAnyShift({
      timeSlotOptions: timeSlotMenu,
      date: date,
      holidays: listHolidays,
      isGrab: is_grab_,
      useTimeSlotRule: USE_TIME_SLOT_RULE,
      isHCMOrder: isHCMOrder_,
    }) ||
    checkOutSideDateAndTime(date, listHolidays, false) ||
    checkIsInFixedDaysOff(fixedDaysOff, date)
  );
};
//
const OrdersFormV2 = props => {
  let queryRouter = useQueryRouter();
  const { t } = useTranslation(["order"]);
  const {
    copiedOrder,
    createOrder,
    customerDetail,
    customers,
    districts,
    locationsCustomer,
    handleChangeCustomer,
    onKeywordsChange,
    onChangeDistrict,
    onChangeProvince,
    onLocationKeywordsChange,
    provinces,
    refetchLocationCustomer,
    wards,
    isMyOrder,
    districtAll,
    wardAll,
    isCreateOrder,
    handleCancel,
    onSelectAddress,
    isHiddenShippingUnit = false,
  } = props;
  const shouldHideShippingUnit = Boolean(isHiddenShippingUnit);
  const { getGroupTransportOption, optionsSelect } = useTransportGroupData();
  const [copiedOrderData, setCopiedOrderData] = useState();

  const [timeSlotsParams, setTimeSlotsParams] = useState({
    params: {
      "filter[hub_id]": undefined,
      "filter[type][in]": [],
      page: -1,
    },
    run: false,
    enabled: false,
    key: "time-slot-v2",
  });

  const {
    data: timeSlots,
    refetch: refetchTimeSlots,
    remove: removeTimeSlots,
  } = useTimeSlots(timeSlotsParams);

  useEffect(() => {
    if (timeSlotsParams && timeSlotsParams?.run) {
      refetchTimeSlots();
    }
  }, [timeSlotsParams]);

  const [timeSlotsParams2Level, setTimeSlotsParams2Level] = useState({
    params: {
      "filter[hub_id]": undefined,
      "filter[type][in]": [],
      page: -1,
    },
    run: false,
    enabled: false,
    key: "time-slot-2-level",
  });

  const {
    data: timeSlots2Level,
    refetch: refetchTimeSlots2Level,
    remove: removeTimeSlots2Level,
  } = useTimeSlots(timeSlotsParams2Level);

  useEffect(() => {
    if (timeSlotsParams2Level && timeSlotsParams2Level?.run) {
      refetchTimeSlots2Level();
    }
  }, [timeSlotsParams2Level]);

  // START GET holidays
  const [holidaysParams, setHolidaysParams] = useState({
    params: {
      columnFilter: {
        "filter[hub_id]": undefined,
      },
      sizePerPage: 10,
      page: -1,
    },
    run: false,
    useToDisalbeCalendar: true,
    queryKey: "holiday-list-order-with-time",
  });

  const {
    data: holidays,
    refetch: fetchHolidays,
    remove: removeHolidays,
  } = useListHolidayWithTime(holidaysParams);

  useEffect(() => {
    if (holidaysParams && holidaysParams?.run) {
      fetchHolidays();
    }
  }, [holidaysParams]);
  // END GET holidays

  // START GET customerLocationTransports
  const [
    customerLocationTransportsParams,
    setCustomerLocationTransportsParams,
  ] = useState({
    customer_id: "",
    province_code: "",
    district_code: "",
    ward_code: "",
    order_type: 2,
    run: false,
  });

  const [fixedDaysOffHub, setFixedDaysOffHub] = useState([]);

  const {
    data: customerLocationTransports,
    refetch: refetchCustomerLocationTransports,
    remove: removeCustomerLocationTransports,
    isFetching: isFetchingLocationTransports,
  } = useGetCustomerLocationTransports(customerLocationTransportsParams);

  useEffect(() => {
    if (
      customerLocationTransportsParams &&
      customerLocationTransportsParams?.run
    ) {
      refetchCustomerLocationTransports();
    }
  }, [customerLocationTransportsParams]);

  useEffect(() => {
    if (customerLocationTransports) {
      const { hub_id, hub_name, hub, transport } = customerLocationTransports;
      const { id, shipping_type } = transport;
      let shippingTypeName = "";
      let arrayTimeSlotType = [];

      switch (shipping_type) {
        case SHIPPING_TYPE.DVVC:
          shippingTypeName = "ĐVVC";
          arrayTimeSlotType = [TIME_SLOT_TYPE.DVVC];
          setValue("isHCMOrder", false);
          removeHolidays();
          break;
        case SHIPPING_TYPE.NHAXE:
          shippingTypeName = "Chành / Nhà xe";
          arrayTimeSlotType = [TIME_SLOT_TYPE.BUS];
          setValue("isHCMOrder", false);
          removeHolidays();
          break;
        case SHIPPING_TYPE.RUNNER:
          shippingTypeName = "RUNNER";
          arrayTimeSlotType = [
            TIME_SLOT_TYPE.COORDINATE,
            TIME_SLOT_TYPE.RUNNER,
          ];
          setValue("isHCMOrder", true);
          if (checkIsInFixedDaysOff(hub?.fixed_days_off, actionDate)) {
            setActionDate(undefined);
            setValue("action_date", undefined);
          }
          setHolidaysParams(prev => {
            return {
              ...prev,
              params: {
                ...prev.params,
                columnFilter: {
                  ...prev.params.columnFilter,
                  "filter[hub_id]": hub_id,
                },
              },
              run: true,
            };
          });
          break;
        default:
          break;
      }

      const transportListData =
        [
          {
            value: id,
            label: shippingTypeName,
            data: transport,
          },
        ] || [];

      if (transportListData?.length > 0) {
        setTimeout(() => {
          setValue("transport_id", transportListData?.[0]);
        });
        handleGetListBusOfTransport(transportListData?.[0], hub_id);
      } else {
        clearTransportAndBusData();
      }

      setFixedDaysOffHub(hub?.fixed_days_off);
      setValue("hub_name", hub_name);
      setShippingType(shipping_type);
      setValue("from_hub", hub_id);
      setValue("transport_list", transportListData);

      setTimeSlotsParams2Level(prev => {
        return {
          ...prev,
          params: {
            ...prev.params,
            "filter[hub_id]": hub_id,
            "filter[type][in]": arrayTimeSlotType,
          },
          run: true,
        };
      });
    } else {
      setValue("hub_name", "");
      clearActionDateAndTimeSlots();
      clearTransportAndBusData();
    }
  }, [customerLocationTransports, copiedOrderData]);

  // END GET customerLocationTransports

  // START GET BUS
  const [busParams, setBusParams] = useState({
    sizePerPage: 10,
    page: 1,
    sort: "-maker_date",
    columnFilter: {
      "filter[record_status]": "O",
    },
    keywords: "",
    columnsVisible: {},
    fields: "",
    expand: "",
    run: false,
  });

  const {
    data: buses,
    refetch: fetchBusList,
    remove: removeBusList,
    isFetching: isFetchingBusList,
  } = useListBus({
    params: busParams,
  });

  useEffect(() => {
    if (busParams && busParams.run) {
      fetchBusList();
    }
  }, [busParams]);

  useEffect(() => {
    const busListData =
      buses?.items?.map(bus => {
        return { label: bus.name, value: bus?.id, data: bus };
      }) || [];
    setValue("bus_list", busListData);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [buses]);
  // END GET BUS

  // START ON CHANGE TRANSPORT/BUS
  const handleGetListBusOfTransport = (transport, hub_id) => {
    switch (transport?.data?.shipping_type) {
      case SHIPPING_TYPE.NHAXE:
        setValue("bus_id", null);
        setBusParams(prev => ({
          ...prev,
          run: true,
          page: -1,
          columnFilter: {
            ...prev.columnFilter,
            "filter[hub_id]": hub_id,
          },
        }));
        break;
      default:
        removeBusList();
        const busListData = [
          {
            value: transport?.value,
            label:
              transport?.data?.shipping_type === SHIPPING_TYPE.DVVC
                ? getGroupTransportOption(
                  transport?.data?.group_code,
                  optionsSelect
                )?.label
                : transport?.data?.name,
            data: transport,
          },
        ];
        setValue("bus_list", busListData);
        setValue("bus_id", busListData[0]);
        break;
    }
  };
  // END ON CHANGE TRANSPORT/BUS

  const [provinceMenu, setProvinceMenu] = useState(
    convertObjectToArray(provinces)
  );
  const [districtMenu, setDistrictMenu] = useState(
    convertObjectToArray(districts)
  );
  const [wardMenu, setWardMenu] = useState(convertObjectToArray(wards));
  const [districtsDefault, setDistrictsDefault] = useState();
  const [wardsDefault, setWardsDefault] = useState();
  const [isDisabledCollectMoney, setIsDisabledCollectMoney] = useState(false);
  const [isDisableActionDate, setIsDisableActionDate] = useState(false);
  const [, setIsDisableAddCustomerButton] = useState(false);

  let timeSearchAddress;
  let timeSearchCustomer;

  useEffect(() => {
    setDistrictsDefault(districtAll);
  }, [districtAll]);
  useEffect(() => {
    setWardsDefault(wardAll);
  }, [wardAll]);

  useEffect(() => {
    setWardMenu(convertObjectToArray(wards));
  }, [wards]);

  useEffect(() => {
    setDistrictMenu(convertObjectToArray(districts));
  }, [districts]);

  useLayoutEffect(() => {
    setValue("bus_id", null);
    setValue("transport_id", null);
  }, []);

  const initDefaultValues = {
    hub_name: "",
    isHCMOrder: false,
    customer_id: null,
    type: 1,
    collect_money: false,
    is_grab: false,
    sender_id: null,
    sender_contact_name: "",
    sender_contact_phone: "",
    sender_address: "",
    sender_ward_code: "",
    sender_district_code: "",
    sender_province_code: "",
    sender_full_address: null,
    from_hub: null,
    transport_id: null,
    transport_list: [],
    bus_list: [],
    bus_id: null,
    runner_id: null,
    // shipping_type: null,
    note: "",
    action_date: "",
    timeslot_id: null,
    resourceBill: undefined,
    resourcePackage: undefined,
  };

  const [shippingType, setShippingType] = useState();

  const rulesHCMOrder = isMyOrder
    ? {
      customer_id: yup
        .object()
        .required(
          t("form.validate.select", {
            title: t("form.receiver_contact_name"),
          })
        )
        .nullable(),
      sender_id: yup
        .string()
        .when((sender_full_address, yupNext) => {
          if (
            localStorage.getItem("user_type") !== "1" &&
            localStorage.getItem("user_type") !== "3"
          ) {
            return yupNext.required();
          }
        })
        .nullable(),
      sender_contact_name: yup.string().required(
        t("form.validate.required", {
          title: t("form.receiver_contact_name"),
        })
      ),
      // sale_id: yup
      //     .object()
      //     .required(
      //         t("form.validate.required", {title: t("form.sale_id")})
      //     )
      //     .nullable(),
      sender_contact_phone: yup
        .string()
        .nullable()
        .required(
          t("form.validate.required", {
            title: t("form.receiver_contact_phone"),
          })
        )
        .matches(
          getPhoneValidation(t).regex,
          getPhoneValidation(t).errorMessage
        )
        .when(getPhoneValidation(t).when),
      sender_full_address: yup
        .object()
        .when((sender_full_address, yupNext) => {
          if (
            localStorage.getItem("user_type") !== "1" &&
            localStorage.getItem("user_type") !== "3"
          ) {
            return yupNext.required(
              t("form.validate.select", {
                title: t("form.receiver_address"),
              })
            );
          }
        })
        .nullable(),
      sender_address: yup
        .string()
        .required(
          t("form.validate.select", { title: t("form.receiver_address") })
        ),
      sender_ward_code: yup
        .object()
        .nullable()
        .required(
          t("form.validate.select", { title: t("form.receiver_ward_code") })
        ),
      // sender_district_code: yup
      //   .object()
      //   .nullable()
      //   .required(
      //     t("form.validate.select", {
      //       title: t("form.receiver_district_code"),
      //     })
      //   ),
      sender_province_code: yup
        .object()
        .nullable()
        .required(
          t("form.validate.select", {
            title: t("form.receiver_province_code"),
          })
        ),
      timeslot_id: yup
        .object()
        .required(t("form.validate.select", { title: t("form.timeslot_id") }))
        .nullable(),
    }
    : {
      customer_id: yup
        .object()
        .required(
          t("form.validate.select", {
            title: t("form.receiver_contact_name"),
          })
        )
        .nullable(),
      sender_contact_name: yup.string().required(
        t("form.validate.required", {
          title: t("form.receiver_contact_name"),
        })
      ),
      sale_id: yup
        .object()
        .required(t("form.validate.required", { title: t("form.sale_id") }))
        .nullable(),
      sender_contact_phone: yup
        .string()
        .nullable()
        .required(
          t("form.validate.required", {
            title: t("form.receiver_contact_phone"),
          })
        )
        .matches(
          getPhoneValidation(t).regex,
          getPhoneValidation(t).errorMessage
        )
        .when(getPhoneValidation(t).when),
      sender_full_address: yup
        .object()
        .when((sender_full_address, yupNext) => {
          if (
            localStorage.getItem("user_type") !== "1" &&
            localStorage.getItem("user_type") !== "3"
          ) {
            return yupNext.required(
              t("form.validate.select", {
                title: t("form.receiver_address"),
              })
            );
          }
        })
        .nullable(),
      sender_address: yup
        .string()
        .required(
          t("form.validate.select", { title: t("form.receiver_address") })
        ),
      sender_ward_code: yup
        .object()
        .nullable()
        .required(
          t("form.validate.select", { title: t("form.receiver_ward_code") })
        ),
      // sender_district_code: yup
      //   .object()
      //   .nullable()
      //   .required(
      //     t("form.validate.select", {
      //       title: t("form.receiver_district_code"),
      //     })
      //   ),
      sender_province_code: yup
        .object()
        .nullable()
        .required(
          t("form.validate.select", {
            title: t("form.receiver_province_code"),
          })
        ),
      timeslot_id: yup
        .object()
        .required(t("form.validate.select", { title: t("form.timeslot_id") }))
        .nullable(),
    };

  const rulesDistrictOrder = {
    ...rulesHCMOrder,
    transport_id: yup
      .object()
      .required(t("form.validate.select", { title: t("form.bus_id") }))
      .nullable(),
    transport_list: yup.array(),
    bus_list: yup.array(),
    bus_id: yup
      .object()
      .required(t("form.validate.select", { title: t("form.bus_id") }))
      .nullable(),
  };

  const rulesDistrictOrderShippingType3 = {
    ...rulesDistrictOrder,
    resourceBill: yup.object().nullable(),
    resourcePackage: yup.object().nullable(),
  };
  // const rules = isHCMOrder
  //   ? rulesHCMOrder
  //   : shippingType === 3
  //   ? rulesDistrictOrderShippingType3
  //   : rulesDistrictOrder;

  const rules = {
    ...rulesHCMOrder,
    ...(shouldHideShippingUnit ? {} : rulesDistrictOrderShippingType3),
  };

  const isAllowCreate = isMyOrder
    ? CheckActionAccess(actionAccess.GLOG_FUNCTION_MY_ORDER_ADD)
    : CheckActionAccess(actionAccess.GLOG_FUNCTION_ORDER_ADD);
  const schema = yup.object().shape(rules);
  // time-slot menu
  // const timeSlotMenuDefault = timeSlots?.items?.map(item => {
  //   return { label: item?.name, value: item };
  // });
  const timeSlotMenuDefault = timeSlots2Level?.items?.map(item => {
    return { label: item?.name, value: item };
  });

  const [timeSlotMenu, setTimeSlotMenu] = useState();
  useEffect(() => {
    setTimeSlotMenu(timeSlotMenuDefault);
  }, [timeSlots2Level?.items]);

  const orderForm = useForm({
    resolver: yupResolver(schema),
    mode: "all",
    reValidateMode: "onChange",
    defaultValues: initDefaultValues,
  });

  const {
    handleSubmit,
    reset,
    formState: { errors, touchedFields },
    control,
    watch,
    setValue,
    getValues,
    setError,
    register,
    unregister,
    clearErrors,
    trigger,
  } = orderForm;

  const {
    isHCMOrder,
    transport_list,
    transport_id,
    bus_list,
    bus_id,
    customer_id,
    sender_full_address,
    sender_province_code,
    sender_ward_code,
    sender_district_code,
    is_grab,
  } = watch();

  const shouldShowShippingUnit = !isHCMOrder && !shouldHideShippingUnit;

  const isThreeLevelAddress =
    sender_full_address?.value?.is_new_address === "O";

  useEffect(() => {
    setProvinceMenu(convertObjectToArray(provinces));
  }, [provinces]);

  const clearTransportAndBusData = () => {
    removeCustomerLocationTransports();
    removeBusList();
    setValue("transport_list", []);
    setValue("transport_id", null);
    setValue("bus_list", []);
    setValue("bus_id", null);
  };

  const clearActionDateAndTimeSlots = () => {
    setTimeSlotMenu([]);
    setValue("timeslot_id", null);
    removeHolidays();
    removeTimeSlots();
    setValue("action_date", moment());
    setActionDate(moment());
  };

  const [customersList, setCustomerList] = useState([]);
  const [locationsCustomerList, setLocationsCustomerList] = useState([]);
  const [focusedInput, setFocusedInput] = useState(false);
  const [actionDate, setActionDate] = useState();
  const [saleList, setSaleList] = useState([]);

  const onSuccessDetailCustomerLocationByOrder = response => {
    const { data } = response;

    if (data && locationsCustomerList) {
      const locationFind = locationsCustomerList.find(
        x => String(x.value.id) === String(data)
      );

      if (locationFind) {
        setValue("sender_full_address", locationFind, {
          shouldValidate: true,
        });
        onSetSenderAddress(locationFind.value);
        if (onSelectAddress) {
          onSelectAddress(locationFind.value);
        }
        onChangeProvince?.(locationFind.value?.province_code);
        onChangeDistrict?.(locationFind.value?.district_code);
      }
    }
  };
  const {
    isLoading: isLoadingDetailCustomerLocationByOrder,
    mutate: onDetailCustomerLocationByOrder,
  } = useDetailCustomerLocationByOrder({
    onSuccess: onSuccessDetailCustomerLocationByOrder,
  });

  useEffect(() => {
    if (!customers) {
      return;
    }
    const customersUpdated = customers.map(customer => {
      return { label: customer.name, value: customer };
    });
    if (!!copiedOrderData) {
      const optionSelected = customersUpdated.find(
        option => option.value.id === copiedOrderData.customer_id
      );

      if (optionSelected) {
        setValue("customer_id", optionSelected);
        handleChangeCustomer(optionSelected?.value?.id);
      } else if (customerDetail) {
        const newOption = {
          label: customerDetail?.name,
          value: customerDetail,
        };
        customersUpdated.push(newOption);
        setValue("customer_id", newOption);
        handleChangeCustomer(customerDetail?.id);
      }
    }
    setCustomerList(customersUpdated);
  }, [customers, copiedOrderData, customerDetail]);
  useEffect(() => {
    setValue("hub_name", "");
    setValue("action_date", moment());
    setActionDate(moment());
    // if (queryRouter.get("sub_order_codes")) {
    //   setValue("note", queryRouter.get("sub_order_codes"));
    // }
  }, []);

  useEffect(() => {
    if (actionDate && timeSlots2Level?.items) {
      const timeSlot = getTimeSlot({
        timeSlotOptions: timeSlotMenuDefault,
        date: actionDate,
        holidays: holidays?.items,
        isGrab: is_grab,
        useTimeSlotRule: USE_TIME_SLOT_RULE,
        isHCMOrder: isHCMOrder,
      });

      if (timeSlot.length === 0 && !isDisableActionDate) {
        const nextDay = moment(actionDate).add(1, "day");

        const nextDayTimeSlots = getTimeSlot({
          timeSlotOptions: timeSlotMenuDefault,
          date: nextDay,
          holidays: holidays?.items,
          isGrab: is_grab,
          useTimeSlotRule: USE_TIME_SLOT_RULE,
          isHCMOrder: isHCMOrder,
        });

        if (nextDayTimeSlots.length > 0) {
          setValue("action_date", nextDay);
          setActionDate(nextDay);
          setTimeSlotMenu(nextDayTimeSlots);
          return;
        }
        // for (let i = 2; i <= 7; i++) {
        //   const futureDay = moment(actionDate).add(i, "day");
        //   const futureDayTimeSlots = getTimeSlot({
        //     timeSlotOptions: timeSlotMenuDefault,
        //     date: futureDay,
        //     holidays: holidays?.items,
        //     isGrab: is_grab,
        //     useTimeSlotRule: USE_TIME_SLOT_RULE,
        //     isHCMOrder: isHCMOrder,
        //   });

        //   if (futureDayTimeSlots.length > 0) {
        //     setValue("action_date", futureDay);
        //     setActionDate(futureDay);
        //     setTimeSlotMenu(futureDayTimeSlots);
        //     return;
        //   }
        // }
      }

      setTimeSlotMenu(timeSlot);
    } else {
      setTimeSlotMenu(timeSlotMenuDefault);
    }
  }, [
    actionDate,
    timeSlots2Level?.items,
    holidays?.items,
    is_grab,
    isHCMOrder,
  ]);

  const handleToggle = id => {
    setLocationsCustomerList(prev =>
      prev.map(item =>
        item.id === id
          ? {
            ...item,
            is_show_in_order: item.is_show_in_order === "Y" ? "N" : "Y",
          }
          : item
      )
    );
  };

  useEffect(() => {
    if (!locationsCustomer) {
      setLocationsCustomerList([]);
      return;
    }
    // const filteredLocations = Array.isArray(locationsCustomer)
    //   ? locationsCustomer.filter(location => location.is_new_address === "N")
    //   : [];
    // // location menu
    // const locationMenu = filteredLocations?.map(

    const picked = [...locationsCustomer]
      .filter(loc => loc?.is_show_in_order === "Y")
      .sort((a, b) => {
        const dateA = a?.checker_date || 0;
        const dateB = b?.checker_date || 0;
        if (dateA !== dateB) return dateB - dateA;
        return (b?.id || 0) - (a?.id || 0);
      });

    const locationMenu = picked.map(
      ({
        id,
        fullAddress,
        contact_name,
        contact_phone,
        address,
        province_code,
        ward_code,
        district_code,
        client_hub_id,
        transport_id,
        transport,
        is_new_address,
        province,
        district,
        ward,
      }) => {
        return {
          label: `${client_hub_id ? `Id: ${client_hub_id} - ` : ""
            }${fullAddress} (${contact_name}, ${contact_phone})`,
          value: {
            id: id,
            address: address,
            fullAddress: fullAddress,
            province_code: province_code,
            ward_code: ward_code,
            district_code: district_code,
            contact_name: contact_name,
            contact_phone: contact_phone,
            // id,
            // address,
            // fullAddress,
            // province_code,
            // ward_code,
            // district_code,
            // contact_name,
            // contact_phone,
            transport_id,
            transport,
            is_new_address,
            province_name: province?.name,
            district_name: district?.name,
            ward_name: ward?.name,
          },
        };
      }
    );

    setLocationsCustomerList(locationMenu);
  }, [locationsCustomer]);

  useEffect(() => {
    if (!!copiedOrderData && locationsCustomerList?.length > 0) {
      const {
        sender_full_address: fullAddress,
        sender_address: address,
        sender_district_code: districtCode,
        sender_province_code: provinceCode,
        sender_ward_code: wardCode,
        sender_contact_name: contactName,
        sender_contact_phone: contactPhone,
        collect_money: collectMoney,
        id_grab: idGrab,
        customer_id: customerId,
      } = copiedOrderData;

      onDetailCustomerLocationByOrder({
        id_order: copiedOrder?.id,
      });

      setCustomerLocationTransportsParams(prev => {
        return {
          ...prev,
          customer_id: customerId,
          province_code: provinceCode,
          ward_code: wardCode,
          order_type: 2,
          run: true,
        };
      });
      setValue("collect_money", Boolean(collectMoney));
      setValue("id_grab", Boolean(idGrab));
      setValue("sender_address", address);
      setValue("sender_full_address", fullAddress);
      setValue("sender_contact_name", contactName);
      setValue("sender_contact_phone", contactPhone);
    }
  }, [copiedOrderData, locationsCustomerList]);
  // useEffect(() => {
  //   if (!!copiedOrderData) {
  //     const { action_date: actionDateCopy, timeslot_id } = copiedOrderData;
  //     const actionDateData = moment(actionDateCopy, "YYYY-MM-DD");
  //     const timeSlotData = timeSlotMenu?.find(
  //       item => item?.value?.id === timeslot_id
  //     );

  //     // setValue("action_date", actionDateData);
  //     setValue("timeslot_id", timeSlotData);
  //     // setActionDate(actionDateData);
  //   }
  // }, [copiedOrderData, timeSlots.items]);

  useEffect(() => {
    if (copiedOrderData && customerLocationTransports) {
      const { transport_id, bus_id } = copiedOrderData?.orderDelivery;
      if (transport_id && transport_list?.length > 0) {
        setValue(
          "bus_id",
          bus_list?.find(b => b.value === transport_id)
        );
      }
      if (bus_id && bus_list?.length > 0) {
        setValue(
          "bus_id",
          bus_list?.find(b => b.value === bus_id)
        );
      }
    }
  }, [copiedOrderData, customerLocationTransports, bus_list, transport_list]);

  useEffect(() => {
    if (!!copiedOrderData) {
      const { sender_province_code: senderProvinceCode } = copiedOrderData;
      setValue(
        "sender_province_code",
        convertObjectToArray(provinces).find(
          option => option.value === senderProvinceCode
        )
      );
      onChangeProvince?.(senderProvinceCode);
    }
  }, [copiedOrderData, provinces]);

  useEffect(() => {
    if (!!copiedOrderData) {
      const { sender_district_code: senderDistrictCode } = copiedOrderData;
      setValue(
        "sender_district_code",
        convertObjectToArray(districts).find(
          option => option.value === senderDistrictCode
        )
      );
      onChangeDistrict?.(senderDistrictCode);
    }
  }, [copiedOrderData, districts]);

  useEffect(() => {
    if (!!copiedOrderData) {
      const {
        sender_ward_code: senderWardCode,
        sender_district_code: senderDistrictCode,
      } = copiedOrderData;
      const wardOptionFromWards = convertObjectToArray(wards).find(
        op => op.value === senderWardCode
      );
      const wardOptionFromDistricts = convertObjectToArray(districts).find(
        op => op.value === senderDistrictCode
      );
      setValue(
        "sender_ward_code",
        wardOptionFromWards || wardOptionFromDistricts || ""
      );
    }
  }, [copiedOrderData, wards, districts]);

  useEffect(() => {
    if (copiedOrder) {
      setCopiedOrderData(copiedOrder);
      Object.keys(copiedOrder).forEach(key => {
        if (key === "note") return;
        setValue(key, copiedOrder[key]);
      });
    }
  }, [copiedOrder]);

  const [open, setOpenPopup] = useState(false);

  const onSetSenderAddress = value => {
    if (value === null) {
      setValue("sender_full_address", null);
    } else {
      const cleanFullAddress =
        value.fullAddress?.replace(/,,+/g, ",") || value.fullAddress;

      setValue("sender_full_address", {
        label: cleanFullAddress,
        value: {
          ...value,
          fullAddress: cleanFullAddress,
        },
      });
      const { province_code, ward_code, district_code } = value;
      setCustomerLocationTransportsParams({
        district_code: district_code,
        customer_id: customer_id?.value?.id,
        province_code: province_code,
        ward_code: ward_code,
        order_type: 2,
        run: true,
      });
    }
    setValue("sender_id", value?.id ? String(value?.id) : null);
    setValue("sender_address", value !== null ? value?.address : "");
    if (value?.is_new_address === "O") {
      localStorage.setItem("address_level", "3");

      // Province
      setValue(
        "sender_province_code",
        value?.province_code
          ? {
            label:
              value?.province_name ||
              provinces?.[value?.province_code] ||
              String(value?.province_code),
            value: value?.province_code,
          }
          : null
      );
      // District
      setValue(
        "sender_district_code",
        value?.district_code
          ? {
            label:
              value?.district_name ||
              districtsDefault?.[value?.district_code] ||
              String(value?.district_code),
            value: value?.district_code,
          }
          : ""
      );
      // Ward
      setValue(
        "sender_ward_code",
        value?.ward_code
          ? {
            label:
              value?.ward_name ||
              wardsDefault?.[value?.ward_code] ||
              String(value?.ward_code),
            value: value?.ward_code,
          }
          : ""
      );
    } else {
      localStorage.setItem("address_level", "2");

      setValue(
        "sender_ward_code",
        value !== null
          ? {
            label:
              value?.district_name ||
              districtsDefault?.[value?.district_code] ||
              String(value?.district_code),
            value: value?.district_code,
          }
          : ""
      );
      setValue("sender_district_code", "");

      onChangeProvince?.(value?.province_code);
      onChangeDistrict?.(value?.district_code);
    }

    if (value && provinceMenu) {
      const province = provinceMenu.find(x => {
        return x.value === value.province_code;
      });
      if (province) setValue("sender_province_code", province);
    }

    setValue("sender_contact_name", value !== null ? value.contact_name : "");
    setValue("sender_contact_phone", value !== null ? value.contact_phone : "");

    setError("sender_full_address");
    setError("sender_address");
    setError("sender_ward_code");
    // setError("sender_district_code");
    setError("sender_province_code");
    setError("sender_contact_name");
    setError("sender_contact_phone");
  };

  const onSetDaySize = () => {
    if (window.matchMedia("(max-width: 369px)").matches) {
      return 22;
    }
    if (window.matchMedia("(max-width: 450px)").matches) {
      return 24;
    }
    return undefined;
  };

  const onSubmit = () => {
    const data = getValues();

    if (data?.timeslot_id && data?.action_date) {
      const currentValidTimeSlots = getTimeSlot({
        timeSlotOptions: timeSlotMenuDefault,
        date: data.action_date,
        holidays: holidays?.items,
        isGrab: data?.is_grab,
        useTimeSlotRule: USE_TIME_SLOT_RULE,
        isHCMOrder: isHCMOrder,
      });

      const isSelectedTimeSlotValid = currentValidTimeSlots.some(
        slot => slot.value.id === data.timeslot_id.value.id
      );

      if (!isSelectedTimeSlotValid) {
        setError("timeslot_id", {
          type: "manual",
          message: "Ca hẹn đã hết hạn, vui lòng chọn ca hẹn khác",
        });
        return;
      }
    }

    const is_grab = data?.is_grab ? 1 : 0;
    const collect_money = data?.collect_money ? 1 : 0;
    const shipping_type = shouldHideShippingUnit
      ? null
      : data?.transport_id?.data?.shipping_type;
    const transport_id = shouldHideShippingUnit
      ? null
      : shipping_type === SHIPPING_TYPE.DVVC
        ? data?.bus_id?.value
        : null;
    const bus_id = shouldHideShippingUnit
      ? null
      : shipping_type === SHIPPING_TYPE.NHAXE
        ? data?.bus_id?.value
        : null;
    const action_date = data?.action_date
      ? moment(data?.action_date).format("YYYY-MM-DD")
      : null;
    const sale_id = data.sale_id ? data.sale_id.value : null;
    const isTwoLevel = !data?.sender_district_code;
    const customer_district_code = isTwoLevel
      ? data?.sender_ward_code?.value
      : data?.sender_district_code?.value;
    const customer_ward_code = isTwoLevel
      ? null
      : data?.sender_ward_code?.value;
    const order = {
      from_hub: data?.from_hub,
      customer_id: data?.customer_id.value.id,
      customer_code: data?.customer_id.value.code,
      type: 2,
      collect_money: isHCMOrder ? collect_money : null,
      is_grab: isHCMOrder ? is_grab : null,
      customer_location_id: data?.sender_id,
      customer_contact_name: data?.sender_contact_name,
      customer_contact_phone: data?.sender_contact_phone,
      customer_address: data?.sender_address,
      customer_ward_code,
      customer_district_code,
      customer_province_code: data?.sender_province_code?.value,
      transport_id: transport_id,
      runner_id: null,
      bus_id: bus_id,
      shipping_type: isHCMOrder
        ? SHIPPING_TYPE.RUNNER
        : shouldHideShippingUnit
          ? null
          : shipping_type,
      note: data?.note,
      action_date: action_date,
      timeslot_id: data?.timeslot_id?.value?.id,
      sale_id: sale_id,
      resources: { bill: [resourceBillId], package: [resourcePackageId] },
      sub_order_codes: queryRouter.get("sub_order_codes")
        ? queryRouter.get("sub_order_codes").split(",")
        : undefined,
    };
    createOrder?.(order);
  };

  const handleChangeProvince = province => {
    setValue("sender_province_code", province);
    setValue("sender_ward_code", null);
    clearTransportAndBusData();

    onChangeProvince?.(province?.value);
  };

  const handleChangeDistrict = district => {
    setValue("sender_district_code", district);
    setValue("sender_ward_code", null);
    clearTransportAndBusData();

    const currentCustomerId = getValues("customer_id")?.value?.id;
    const currentProvinceCode = getValues("sender_province_code")?.value;

    if (currentCustomerId && currentProvinceCode && district?.value) {
      setCustomerLocationTransportsParams({
        customer_id: currentCustomerId,
        province_code: currentProvinceCode,
        district_code: district.value,
        ward_code: district.value,
        order_type: 2,
        run: true,
      });
    }

    onChangeDistrict?.(district?.value);
  };

  const handleChangeGrab = grab => {
    const is_grab = !getValues("is_grab");

    let timeSlot = getTimeSlot({
      timeSlotOptions: timeSlotMenuDefault,
      date: actionDate,
      holidays: holidays?.items,
      isGrab: is_grab,
      useTimeSlotRule: USE_TIME_SLOT_RULE,
      isHCMOrder: isHCMOrder,
    });

    if (is_grab) {
      setValue("collect_money", false);
      setValue("is_grab", true);
      setActionDate(moment());
      setIsDisabledCollectMoney(true);
      setIsDisableActionDate(true);
    } else {
      setValue("is_grab", false);
      setIsDisabledCollectMoney(false);
      setIsDisableActionDate(false);
    }

    const timeslot_id = getValues("timeslot_id");
    const isFindTimeSlotId = timeSlot.find(
      time => time?.value?.id == timeslot_id?.value?.id
    );
    if (timeslot_id && !isFindTimeSlotId) {
      setValue("timeslot_id", null);
    }
    setTimeSlotMenu(timeSlot);
  };

  const onUploadBillSuccess = response => {
    if (response?.data?.id) {
      setResourceBillId(response?.data?.id);
    }
  };

  const onUploadPackageSuccess = response => {
    if (response?.data?.id) {
      setResourcePackageId(response?.data?.id);
    }
  };

  const [resourceBillId, setResourceBillId] = useState(null);
  const [resourcePackageId, setResourcePackageId] = useState(null);

  const { mutate: uploadResourceBill } = useUploadResource(onUploadBillSuccess);
  const { mutate: uploadResourcePackage } = useUploadResource(
    onUploadPackageSuccess
  );

  const onRemoveFileBill = res => {
    setValue("resourceBill", undefined);
    setResourceBillId(null);
  };

  const handleFilesBill = files => {
    if (files.length > 0) {
      const data = new FormData();
      data.append("file", files[0]);
      setValue("resourceBill", {}, { shouldValidate: true });
      uploadResourceBill(data);
    }
  };

  const onRemoveFilePackage = res => {
    setValue("resourcePackage", undefined);
    setResourceBillId(null);
  };

  const handleFilesPackage = files => {
    if (files.length > 0) {
      const data = new FormData();
      data.append("file", files[0]);
      setValue("resourcePackage", {}, { shouldValidate: true });
      uploadResourcePackage(data);
    }
  };

  return (
    <Card body className="order-form" style={{ marginBottom: "150px" }}>
      <Form>
        <Row md={1}>
          <Col>
            {!isMyOrder && (
              <Row xs={1} md={2}>
                <Col>
                  <FormGroup className="gy-2">
                    <Label htmlFor="customer_id">
                      {t("form.customer")}{" "}
                      <span className="text-danger">*</span>
                    </Label>
                    <Controller
                      control={control}
                      name="customer_id"
                      render={({ field }) => (
                        <Select
                          {...field}
                          placeholder={t("placeholder.select", {
                            title: t("form.customer"),
                          })}
                          options={customersList}
                          classNamePrefix="select"
                          isSearchable
                          className="basic-single w-100"
                          onChange={data => {
                            field.onChange(data);
                            removeCustomerLocationTransports();
                            setCopiedOrderData(null);
                            onSetSenderAddress(null);
                            if (onSelectAddress) {
                              onSelectAddress(null);
                            }
                            setValue("sale_id", null);
                            setValue("sender_province_code", null);
                            setValue("sender_district_code", null);
                            setValue("sender_ward_code", null);
                            setValue("sender_address", "");
                            setValue("sender_contact_name", "");
                            setValue("sender_contact_phone", "");
                            clearTransportAndBusData();
                            handleChangeCustomer(data.value.id);
                          }}
                          onInputChange={(keywords, actions) => {
                            clearTimeout(timeSearchCustomer);
                            timeSearchCustomer = setTimeout(() => {
                              if ((actions.action = "input-change")) {
                                if (keywords) {
                                  onKeywordsChange?.(
                                    keywords.trim().replaceAll(" ", "+")
                                  );
                                } else {
                                  onKeywordsChange?.("");
                                }
                              }
                            }, 500);
                          }}
                          onBlur={() => onKeywordsChange?.("")}
                        />
                      )}
                    />
                    {errors.customer_id && (
                      <MessageFormValidate error={errors.customer_id.message} />
                    )}
                  </FormGroup>
                </Col>
                <Col>
                  <FormGroup className="gy-2">
                    <Label htmlFor="sale_id">
                      {t("form.sale_id")} <span className="text-danger">*</span>
                    </Label>
                    <Controller
                      control={control}
                      name="sale_id"
                      render={({ field }) => (
                        <SaleSelect
                          {...field}
                          customerId={watch("customer_id")?.value.id}
                          setSale={setValue}
                          isSearchable
                          // isDisabled={!watch("province_code")}
                          onChange={e => {
                            setValue("sale_id", e, { shouldValidate: true });
                          }}
                        />
                      )}
                    />
                    {errors.sale_id && (
                      <MessageFormValidate error={errors.sale_id.message} />
                    )}
                  </FormGroup>
                </Col>
              </Row>
            )}
            {isMyOrder && (
              <FormGroup className="gy-2">
                <Label htmlFor="customer_id">
                  {t("form.customer")} <span className="text-danger">*</span>
                </Label>
                <Controller
                  control={control}
                  name="customer_id"
                  render={({ field }) => (
                    <Select
                      {...field}
                      placeholder={t("placeholder.select", {
                        title: t("form.customer"),
                      })}
                      options={customersList}
                      classNamePrefix="select"
                      isSearchable
                      className="basic-single w-100"
                      onChange={data => {
                        field.onChange(data);
                        setCopiedOrderData(null);
                        onSetSenderAddress(null);
                        clearTransportAndBusData();
                        handleChangeCustomer(data.value.id);
                      }}
                      onInputChange={(keywords, actions) => {
                        clearTimeout(timeSearchCustomer);
                        timeSearchCustomer = setTimeout(() => {
                          if (actions.action == "input-change") {
                            if (keywords) {
                              onKeywordsChange?.(
                                keywords.trim().replaceAll(" ", "+")
                              );
                            } else {
                              onKeywordsChange?.("");
                            }
                          }
                        }, 500);
                      }}
                      onBlur={() => onKeywordsChange?.("")}
                    />
                  )}
                />
                {errors.customer_id && (
                  <MessageFormValidate error={errors.customer_id.message} />
                )}
              </FormGroup>
            )}
            <Row xs={1} md={2}>
              <Col>
                <FormGroup>
                  <Label htmlFor="address_order">
                    {t("form.position_pick_order")}{" "}
                    <span className="text-danger">*</span>
                  </Label>
                  <InputGroup style={{ flexWrap: "unset" }}>
                    <Controller
                      control={control}
                      name="sender_full_address"
                      render={({ field }) => (
                        <Select
                          {...field}
                          placeholder={t("placeholder.select", {
                            title: t("form.receiver_address"),
                          })}
                          className="basic-single w-100"
                          classNamePrefix="select"
                          options={locationsCustomerList}
                          onChange={data => {
                            handleToggle(data.value.id);

                            // const selectedValue = data ? data.value : null;
                            // if (selectedValue) {
                            //   handleToggle(selectedValue.id);
                            // }
                            field.onChange(data);
                            setCopiedOrderData(null);
                            onSetSenderAddress(data.value);
                            onChangeProvince?.(data.value?.province_code);
                            onChangeDistrict?.(data.value?.district_code);
                            setValue("timeslot_id", null);
                            clearErrors("bus_id");
                            if (onSelectAddress) {
                              onSelectAddress(selectedValue);
                            }
                          }}
                          required
                          isDisabled={isLoadingDetailCustomerLocationByOrder}
                          isSearchable
                          onInputChange={(keywords, actions) => {
                            clearTimeout(timeSearchAddress);
                            timeSearchAddress = setTimeout(() => {
                              if (actions.action == "input-change") {
                                if (keywords) {
                                  onLocationKeywordsChange?.(
                                    keywords.trim().replaceAll(" ", "+")
                                  );
                                } else {
                                  onLocationKeywordsChange?.("");
                                }
                              }
                            }, 500);
                          }}
                          onBlur={() => onLocationKeywordsChange?.("")}
                        />
                      )}
                    />
                    {!bus_list?.some(b => b?.data?.code === "cpn247") && (
                      <Button
                        style={{ backgroundColor: "#3C64B1", zIndex: 0 }}
                        color="primary"
                        disabled={String(bus_id?.value) === "9" && isMyOrder}
                        onClick={() => {
                          if (getValues("customer_id")) setOpenPopup(!open);
                          else
                            setError(
                              "customer_id",
                              { type: "focus" },
                              { shouldFocus: true }
                            );
                        }}
                      >
                        {t("button.add")}
                      </Button>
                    )}

                    <Modal
                      isOpen={open}
                      centered
                      toggle={() => {
                        setOpenPopup(!open);
                      }}
                    >
                      <LocationCustomerForm
                        // isHCMOrder={isHCMOrder}
                        handleCancel={() => {
                          refetchLocationCustomer?.();
                          setOpenPopup(false);
                        }}
                        provinces={provinces}
                        districts={districts}
                        wards={wards}
                        customer_id={getValues("customer_id")?.value?.id}
                        onChangeProvince={onChangeProvince}
                        onChangeDistrict={onChangeDistrict}
                      />
                    </Modal>
                  </InputGroup>
                  {errors.sender_full_address && (
                    <MessageFormValidate
                      error={errors.sender_full_address.message}
                    />
                  )}
                </FormGroup>
                <Row xs={1} md={2}>
                  <Col
                    style={{ display: isThreeLevelAddress ? "none" : "block" }}
                  >
                    <FormGroup>
                      <Label
                        htmlFor="sender_address"
                        className="visually-hidden"
                      >
                        {t("form.receiver_address")}
                      </Label>
                      <input
                        className={`form-control`}
                        id="sender_address"
                        type="text"
                        disabled={isFetchingLocationTransports}
                        placeholder={t("placeholder.enter", {
                          title: t("form.receiver_address"),
                        })}
                        {...register("sender_address")}
                      />
                      {errors.sender_address && (
                        <MessageFormValidate
                          error={errors.sender_address.message}
                        />
                      )}
                    </FormGroup>
                  </Col>
                  <Col
                    style={{ display: isThreeLevelAddress ? "none" : "block" }}
                  >
                    <FormGroup>
                      <Label
                        htmlFor="sender_province_code"
                        className="visually-hidden"
                      >
                        {t("form.receiver_province_code")}
                      </Label>
                      <Controller
                        control={control}
                        name="sender_province_code"
                        render={({ field }) => (
                          <Select
                            {...field}
                            placeholder={t("placeholder.select", {
                              title: t("form.receiver_province_code"),
                            })}
                            options={provinceMenu}
                            isSearchable
                            className="basic-single w-100"
                            classNamePrefix="select"
                            onChange={handleChangeProvince}
                            // isDisabled={
                            //   isFetchingLocationTransports ||
                            //   !!sender_full_address
                            // }
                            isDisabled={false}
                          />
                        )}
                      />
                      {errors.sender_province_code && (
                        <MessageFormValidate
                          error={errors.sender_province_code.message}
                        />
                      )}
                    </FormGroup>
                  </Col>
                  {sender_full_address?.value?.is_new_address === "O" && (
                    <Col
                      style={{
                        display: isThreeLevelAddress ? "none" : "block",
                      }}
                    >
                      <FormGroup>
                        <Label
                          htmlFor="sender_district_code"
                          className="visually-hidden"
                        >
                          {t("form.receiver_district_code")}
                        </Label>
                        <Controller
                          control={control}
                          name="sender_district_code"
                          render={({ field }) => (
                            <Select
                              {...field}
                              placeholder={t("placeholder.select", {
                                title: t("form.receiver_district_code"),
                              })}
                              options={districtMenu}
                              isSearchable
                              className="basic-single w-100"
                              classNamePrefix="select"
                              // isDisabled={
                              //   !getValues("sender_province_code") ||
                              //   isFetchingLocationTransports ||
                              //   !!sender_full_address
                              // }
                              isDisabled={false}
                              onChange={handleChangeDistrict}
                            />
                          )}
                        />
                        {errors.sender_district_code && (
                          <MessageFormValidate
                            error={errors.sender_district_code.message}
                          />
                        )}
                      </FormGroup>
                    </Col>
                  )}

                  <Col
                    style={{ display: isThreeLevelAddress ? "none" : "block" }}
                  >
                    <FormGroup>
                      <Label
                        htmlFor="sender_ward_code"
                        className="visually-hidden"
                      >
                        {t("form.receiver_ward_code")}
                      </Label>
                      <Controller
                        control={control}
                        name="sender_ward_code"
                        render={({ field }) => (
                          <Select
                            {...field}
                            placeholder={t("placeholder.select", {
                              title:
                                sender_full_address?.value?.is_new_address ===
                                  "O"
                                  ? t("form.receiver_ward_code")
                                  : t("form.receiver_ward_code"),
                            })}
                            options={
                              sender_full_address?.value?.is_new_address === "O"
                                ? wardMenu
                                : districtMenu
                            }
                            isSearchable
                            // isDisabled={
                            //   !getValues("sender_province_code") ||
                            //   isFetchingLocationTransports ||
                            //   !!sender_full_address
                            // }
                            isDisabled={false}
                            className="basic-single w-100"
                            classNamePrefix="select"
                            onChange={data => {
                              field.onChange(data);

                              const currentCustomerId =
                                getValues("customer_id")?.value?.id;
                              const currentProvinceCode = getValues(
                                "sender_province_code"
                              )?.value;
                              // const currentDistrictCode =
                              // sender_full_address?.value?.is_new_address ===
                              // "O"
                              //   ? getValues("sender_district_code")?.value
                              //   : data?.value;
                              const isThreeLevelAddr =
                                sender_full_address?.value?.is_new_address ===
                                "O";

                              if (
                                currentCustomerId &&
                                currentProvinceCode &&
                                data?.value
                              ) {
                                if (isThreeLevelAddr) {
                                  const currentDistrictCode = getValues(
                                    "sender_district_code"
                                  )?.value;
                                  setCustomerLocationTransportsParams({
                                    customer_id: currentCustomerId,
                                    province_code: currentProvinceCode,
                                    // district_code:
                                    // currentDistrictCode || data.value,
                                    district_code: currentDistrictCode,
                                    ward_code: data.value,
                                    order_type: 2,
                                    run: true,
                                  });
                                } else {
                                  setCustomerLocationTransportsParams({
                                    customer_id: currentCustomerId,
                                    province_code: currentProvinceCode,
                                    district_code: data.value,
                                    order_type: 2,
                                    run: true,
                                  });
                                }
                              }
                            }}
                          />
                        )}
                      />
                      {errors.sender_ward_code && (
                        <MessageFormValidate
                          error={errors.sender_ward_code.message}
                        />
                      )}
                    </FormGroup>
                  </Col>
                  {/* <Col>
                    <FormGroup>
                      <Label
                        htmlFor="sender_district_code"
                        className="visually-hidden"
                      >
                        {t("form.receiver_district_code")}
                      </Label>
                      <Controller
                        control={control}
                        name="sender_district_code"
                        render={({ field }) => (
                          <Select
                            {...field}
                            placeholder={t("placeholder.select", {
                              title: t("form.receiver_district_code"),
                            })}
                            options={districtMenu}
                            isSearchable
                            className="basic-single w-100"
                            classNamePrefix="select"
                            isDisabled={
                              !getValues("sender_province_code") ||
                              isFetchingLocationTransports
                            }
                            onChange={handleChangeDistrict}
                          />
                        )}
                      />
                      {errors.sender_district_code && (
                        <MessageFormValidate
                          error={errors.sender_district_code.message}
                        />
                      )}
                    </FormGroup>
                  </Col> */}

                  <Col>
                    <FormGroup>
                      <Label
                        htmlFor="sender_contact_name"
                        className="visually-hidden"
                      >
                        {t("form.receiver_contact_name")}
                      </Label>
                      <input
                        type="text"
                        id="sender_contact_name"
                        placeholder={t("placeholder.enter", {
                          title: t("form.receiver_contact_name"),
                        })}
                        disabled={isFetchingLocationTransports}
                        className={`form-control `}
                        {...register("sender_contact_name")}
                      />
                      {errors.sender_contact_name && (
                        <MessageFormValidate
                          error={errors.sender_contact_name.message}
                        />
                      )}
                    </FormGroup>
                  </Col>
                  <Col>
                    <FormGroup>
                      <Label
                        htmlFor="sender_contact_phone"
                        className="visually-hidden"
                      >
                        {t("form.receiver_contact_phone")}
                      </Label>
                      <input
                        type="number"
                        id="sender_contact_phone"
                        placeholder={t("placeholder.enter", {
                          title: t("form.receiver_contact_phone"),
                        })}
                        disabled={isFetchingLocationTransports}
                        className={`form-control`}
                        {...register("sender_contact_phone")}
                      />
                      {errors.sender_contact_phone && (
                        <MessageFormValidate
                          error={errors.sender_contact_phone.message}
                        />
                      )}
                    </FormGroup>
                  </Col>
                </Row>
                <Row xs={1} md={2}>
                  {!isMyOrder && (
                    <Col>
                      <FormInput
                        isDisabled={true}
                        // isRequired
                        isLabel={true}
                        t={t}
                        fieldName="hub_name"
                        type="text"
                        mainForm={orderForm}
                        title={"Center/Hub nhận mẫu"}
                      />
                    </Col>
                  )}
                </Row>
                <Label htmlFor="orderTime">
                  {t("form.timeslot_id")} <span className="text-danger">*</span>
                </Label>
                <Row xs={1} md={2}>
                  {shippingType === SHIPPING_TYPE.DVVC &&
                    !Boolean(
                      transport_list[0]?.data?.allowed_select_action_date
                    ) ? null : (
                    <Col>
                      <FormGroup>
                        <div
                          className="d-flex align-items-center action_date_input"
                          style={{ backgroundColor: "#f4f5f4" }}
                        >
                          <span
                            style={{ paddingLeft: "12px" }}
                            className="prefix"
                          >
                            {t("form.action_date_label")}
                          </span>
                          <Controller
                            control={control}
                            name="action_date"
                            render={({ field }) => (
                              <SingleDatePicker
                                {...field}
                                date={actionDate}
                                onDateChange={date => {
                                  setValue("action_date", date);
                                  setActionDate(date);
                                  setError("action_date");
                                  setValue("timeslot_id", null);
                                }}
                                focused={focusedInput}
                                onFocusChange={({ focused }) =>
                                  setFocusedInput(focused)
                                }
                                isOutsideRange={
                                  shippingType === SHIPPING_TYPE.RUNNER
                                    ? date =>
                                      checkIsDisableDate(
                                        date,
                                        holidays?.items,
                                        fixedDaysOffHub,
                                        timeSlotMenuDefault,
                                        isHCMOrder,
                                        is_grab
                                      )
                                    : undefined
                                }
                                displayFormat="DD/MM/YYYY"
                                numberOfMonths={1}
                                small
                                placeholder=""
                                showDefaultInputIcon
                                inputIconPosition="after"
                                readOnly
                                daySize={onSetDaySize()}
                                disabled={
                                  isDisableActionDate ||
                                  isFetchingLocationTransports
                                }
                              />
                            )}
                          />
                        </div>
                        {errors.action_date && (
                          <MessageFormValidate
                            error={errors.action_date.message}
                          />
                        )}
                      </FormGroup>
                    </Col>
                  )}
                  <Col>
                    <FormGroup>
                      <Label htmlFor="orderHour" className="visually-hidden" />
                      <Controller
                        control={control}
                        name="timeslot_id"
                        render={({ field }) => (
                          <Select
                            {...field}
                            placeholder={t("placeholder.select", {
                              title: t("form.timeslot_id"),
                            })}
                            id="orderHour"
                            className="basic-single"
                            classNamePrefix="select"
                            isSearchable
                            options={timeSlotMenu}
                            isDisabled={
                              (isHCMOrder && !getValues("action_date")) ||
                              isFetchingLocationTransports
                            }
                          />
                        )}
                      />
                      {errors.timeslot_id && (
                        <MessageFormValidate
                          error={errors.timeslot_id.message}
                        />
                      )}
                    </FormGroup>
                  </Col>
                  {isHCMOrder && (
                    <>
                      <Col>
                        <FormGroup
                          className="orders-card d-flex align-items-center"
                          style={{ padding: "12px" }}
                        >
                          <input
                            disabled={
                              isDisabledCollectMoney ||
                              isFetchingLocationTransports
                            }
                            name="get-money"
                            type="checkbox"
                            className="mt-0"
                            {...register("collect_money")}
                          />
                          <Label
                            check
                            htmlFor="get-money"
                            style={{
                              marginLeft: "8px",
                              fontWeight: "400",
                            }}
                          >
                            {t("form.collect_money")}
                          </Label>
                        </FormGroup>
                      </Col>
                      <Col>
                        <FormGroup
                          className="orders-card d-flex align-items-center"
                          style={{ padding: "12px" }}
                        >
                          <input
                            name="is-grab"
                            disabled={isFetchingLocationTransports}
                            type="checkbox"
                            className="mt-0"
                            {...register("is_grab")}
                            onChange={handleChangeGrab}
                          />
                          <Label
                            check
                            htmlFor="is-grab"
                            style={{
                              marginLeft: "8px",
                              fontWeight: "400",
                            }}
                          >
                            {t("form.is_grab")}
                          </Label>
                        </FormGroup>
                      </Col>
                    </>
                  )}
                </Row>
                {shouldShowShippingUnit && (
                  <>
                    <Label htmlFor="shipping_type">
                      {t("form.shipping_type")}{" "}
                      <span className="text-danger">*</span>
                    </Label>
                    {/* {getValues("customer_id") !== null &&
                      transport_list?.length === 0 && (
                        <MessageFormValidate
                          error={t("message.no_customer_shipping_type")}
                        />
                      )} */}
                    <Row xs={1} md={2}>
                      <Col>
                        <FormGroup>
                          <Controller
                            control={control}
                            name="transport_id"
                            render={({ field }) => (
                              <Select
                                {...field}
                                placeholder={t("placeholder.select", {
                                  title: t("form.shipping_type"),
                                })}
                                isDisabled={isFetchingLocationTransports}
                                className="basic-single"
                                classNamePrefix="select"
                                isSearchable
                                options={transport_list || []}
                                onChange={data => {
                                  field.onChange(data);
                                  handleGetListBusOfTransport(data);
                                }}
                              />
                            )}
                          />
                          {errors.transport_id && (
                            <MessageFormValidate
                              error={errors.transport_id.message}
                            />
                          )}
                        </FormGroup>
                      </Col>
                      <Col>
                        <FormGroup>
                          <Label htmlFor="bus_id" className="visually-hidden" />
                          <Controller
                            control={control}
                            name="bus_id"
                            render={({ field }) => (
                              <Select
                                {...field}
                                placeholder={t("placeholder.select", {
                                  title:
                                    shippingType === SHIPPING_TYPE.NHAXE
                                      ? "Chành / Nhà xe"
                                      : "ĐVVC",
                                })}
                                id="bus_id"
                                className="basic-single"
                                classNamePrefix="select"
                                isLoading={isFetchingBusList}
                                isDisabled={
                                  isFetchingBusList ||
                                  isFetchingLocationTransports ||
                                  transport_id?.data?.shipping_type !==
                                  SHIPPING_TYPE.NHAXE
                                }
                                options={bus_list}
                                onChange={value => {
                                  field.onChange(value);

                                  setIsDisableAddCustomerButton(
                                    String(value?.value?.id) === "9"
                                  );
                                }}
                                isSearchable
                              // onInputChange={(keywords, actions) => {
                              //   clearTimeout(timeSearchBus);
                              //   timeSearchBus = setTimeout(
                              //     () =>
                              //       onSearchBusChange({ keywords, actions }),
                              //     500
                              //   );
                              // }}
                              // onBlur={e =>
                              //   onSearchBusChange({
                              //     keywords: "",
                              //     actions: { action: "input-change" },
                              //   })
                              // }
                              />
                            )}
                          />
                          {errors.bus_id && (
                            <MessageFormValidate
                              error={errors.bus_id.message}
                            />
                          )}
                        </FormGroup>
                      </Col>
                      {transport_id?.data?.shipping_type ===
                        SHIPPING_TYPE.NHAXE ? (
                        <Col>
                          <FormGroup className="mb-3">
                            <Label htmlFor="avatar">
                              {t("form.upload_bill")}
                            </Label>
                            <UploadForm
                              removeFile={onRemoveFileBill}
                              multiple={false}
                              handleFiles={files => handleFilesBill(files)}
                              accept=".jpg"
                            ></UploadForm>
                            <input
                              style={{ display: "none" }}
                              {...register("resourceBill")}
                            ></input>
                            {errors.resourceBill && (
                              <MessageFormValidate
                                error={errors.resourceBill.message}
                              />
                            )}
                          </FormGroup>
                        </Col>
                      ) : null}
                      {transport_id?.data?.shipping_type ===
                        SHIPPING_TYPE.NHAXE ? (
                        <Col>
                          <FormGroup className="mb-3">
                            <Label htmlFor="avatar">
                              {t("form.upload_package")}
                            </Label>
                            <UploadForm
                              removeFile={onRemoveFilePackage}
                              multiple={false}
                              handleFiles={files => handleFilesPackage(files)}
                              accept=".jpg"
                            ></UploadForm>
                            <input
                              style={{ display: "none" }}
                              {...register("resourcePackage")}
                            ></input>
                            {errors.resourcePackage && (
                              <MessageFormValidate
                                error={errors.resourcePackage.message}
                              />
                            )}
                          </FormGroup>
                        </Col>
                      ) : null}
                    </Row>
                  </>
                )}
              </Col>
              <Col>
                <FormGroup>
                  <Label htmlFor="note">{t("form.note")}</Label>
                  <textarea
                    type="textarea"
                    className={`form-control ${formValidate(
                      errors,
                      touchedFields,
                      "note"
                    )}`}
                    name="note"
                    placeholder={t("placeholder.note")}
                    rows={9}
                    {...register("note")}
                  />
                </FormGroup>
              </Col>
            </Row>
          </Col>
          <Col xs={12} md={6}>
            <Row xs={2}>
              <Col>
                <Button
                  color="danger"
                  outline
                  className="border-0"
                  size="xs"
                  onClick={() => handleCancel()}
                >
                  {t("button.cancel")}
                </Button>
              </Col>
              {isAllowCreate && (
                <Col className="text-end">
                  <Button
                    disabled={
                      (bus_id?.data?.data?.code?.includes("cpn247") &&
                        !sender_full_address) ||
                      isCreateOrder ||
                      isLoadingDetailCustomerLocationByOrder
                    }
                    size="xs"
                    color="primary"
                    style={{ backgroundColor: "#3C64B1" }}
                    onClick={() => {
                      handleSubmit(onSubmit)();
                    }}
                  >
                    {t("button.confirm")}
                  </Button>
                </Col>
              )}
            </Row>
          </Col>
        </Row>
      </Form>
    </Card>
  );
};

OrdersFormV2.propTypes = {
  customers: PropTypes.array,
  locationsCustomer: PropTypes.array,
  handleChangeCustomer: PropTypes.func,
  provinces: PropTypes.object,
  districts: PropTypes.object,
  wards: PropTypes.object,
  createOrder: PropTypes.func,
  refetchLocationCustomer: PropTypes.func,
  onChangeProvince: PropTypes.func,
  onChangeDistrict: PropTypes.func,
  onKeywordsChange: PropTypes.func,
  handleCancel: PropTypes.func,
  onLocationKeywordsChange: PropTypes.func,
  copiedOrder: PropTypes.object,
  customerDetail: PropTypes.object,
  isMyOrder: PropTypes.bool,
  districtAll: PropTypes.object,
  wardAll: PropTypes.object,
  isCreateOrder: PropTypes.bool,
  onSelectAddress: PropTypes.func,
  isHiddenShippingUnit: PropTypes.bool,
};
export default OrdersFormV2;
